/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Section_Documents_Upload_HintInputs */

const en_case_section_documents_upload_hint = /** @type {(inputs: Case_Section_Documents_Upload_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload documents after the case is saved.`)
};

const pt_br2_case_section_documents_upload_hint = /** @type {(inputs: Case_Section_Documents_Upload_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faça upload de documentos após salvar o caso.`)
};

/**
* | output |
* | --- |
* | "Upload documents after the case is saved." |
*
* @param {Case_Section_Documents_Upload_HintInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_section_documents_upload_hint = /** @type {((inputs?: Case_Section_Documents_Upload_HintInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Section_Documents_Upload_HintInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_section_documents_upload_hint(inputs)
	return pt_br2_case_section_documents_upload_hint(inputs)
});